<app-ao-editor [isSearchingMode]="true"></app-ao-editor>
